




















import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class TicketList extends Mixins(DateMethods, TicketHelper) {
    @Prop({ default: null }) public project: number;

    public tableEntity: string = 'TicketList';

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.ticket-id', 'Ticket ID'), align: 'left', sortable: true, required: false, html: true, filter: false,
                field: (row: any) => !row.firstResponse ? `<b><span class="unseen-ticket-dot"></span>${row.id}</b>` : row.id,
            },
            { name: 'title', label: this.$t('general.title', 'Title'), align: 'left', sortable: true, required: false, html: true, filter: false,
                field: (row: any) =>  this.makeColumnBold(row.firstResponse, row.title),
            },
            {
                name: 'message',
                label: this.$t('general.ticket-message', 'Ticket message'),
                align: 'left',
                sortable: true,
                required: false,
                filter: false,
                ignoreFieldForCsv: true,
                field: (row: any) =>  row.message.length > 30 ? row.message.substr(0, 30) + '...' : row.message,
            },
            { name: 'created_at', label: this.$t('general.submit-date', 'Submit date'), align: 'left', sortable: true, required: false, html: true, filter: false,
                field: (row: any) =>  this.makeColumnBold(row.firstResponse, row.created_at),
            },
            { name: 'category', label: this.$t('general.ticket-category', 'Ticket Category'), align: 'left', sortable: true, required: false, field: 'category'},
            { name: 'project', label: this.$t('general.project', 'Project'), align: 'left', sortable: true, required: false, field: 'project' },
            { name: 'address', label: this.$t('general.address', 'Address'), align: 'left', sortable: true, required: false, field: 'full_address' },
            { name: 'property_title_number', label: this.$t('general.unit-id', 'Unit ID'), align: 'left', sortable: true, required: false, html: true, filter: false,
                field: (row: any) =>  this.makeColumnBold(row.firstResponse, row.property_title_number),
            },
            { name: 'type', label: this.$t('general.ticket-subject', 'Ticket Subject'), align: 'left', sortable: true, required: false, field: 'type'},
            { name: 'state', label: this.$t('general.status', 'Status'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) =>  this.returnTicketState(row.state),
            },
            { name: 'priority', label: this.$t('general.priority', 'Priority'), align: 'left', sortable: true, required: false, html: true, filter: false,
                field: (row: any) =>  `<b class="badge normal-badge badge-rounded ticket-badges ${this.priorityBadgeClass(row.priority)}">${this.ticketPriorityTextById(row.priority)}</b>`,
            },
            { name: 'assignee_name', label: this.$t('general.assignee', 'Assignee'), align: 'left', field: 'assignee_name', sortable: true, required: false },
            { name: 'firstResponse', label: this.$t('general.last-staff-activity', 'Last Staff activity'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) =>  row.firstResponse ? (this.firstResponseDate(row.firstResponse) + (row.firstResponder ? ` (${this.firstResponseName(row.firstResponder)})` : ''))  : this.$t('general.no-response', 'No response'),
            },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'title',
                'message',
                'project',
                'created_at',
                'category',
                'property_title_number',
                'type',
                'state',
                'priority',
                'assignee_name',
                'firstResponse',
                'full_address',
            ],
        };
    }

    get ticketsList(): any {
        return this.$store.getters['Tickets/getAllTickets'];
    }

    get filteredTickets() {
        if (!this.project) {
            return this.ticketsList;
        }

        return this.ticketsList.filter((t) => t.project_id === this.project);
    }

    public makeColumnBold(firstResponse: any, column: any)  {
        return !firstResponse ? `<b>${column}</b>` : column;
    }

    public firstResponseDate(date: any)  {
        return this.$moment(date).local().fromNow();
    }

    public firstResponseName(user: any)  {
        return user.person ? `${user.person.first_name} ${user.person.family_name}` : user.name;
    }

    public fetchCurrentTicket(ticketId: number)  {
        this.$store.dispatch(Actions.OPEN_TICKET_MODAL, ticketId);
    }

    public returnTicketState(state: string) {
        if (state === 'new') {
            return 'Pending';
        } else if (state === 'open') {
            return 'In-progress';
        } else if (state === 'closed') {
            return 'Cancelled';
        } else {
            return 'Completed';
        }
    }

    public returnTypeCapitalize(type: string) {
        return type.charAt(0).toUpperCase() + type.slice(1);
    }
}
